import React from 'react';
import './InputWrapper.style.css';

import { ReactComponent as TooltipModalIcon } from '../../assets/modal-icon.svg';
import { makeStyles, Tooltip } from '@material-ui/core';

export interface InputWrapperProps {
	inputWrapperLabel: string;
	tooltipModalText?: string;
}

const useStyles = makeStyles(() => ({
	customTooltip: {
		backgroundColor: '#f0f2f5',
		color: '#000',
		fontSize: '1rem',
		padding: '1rem',
	},
	customArrow: {
		color: '#f0f2f5',
		width: '2em',
		height: '1.42em',
		marginBottom: '-1.3em !important',
	},
}));

const InputWrapper: React.FC<InputWrapperProps> = ({
	children,
	inputWrapperLabel,
	tooltipModalText,
}) => {
	const classes = useStyles();

	return (
		<div className="input-wrapper">
			<h4
				className={`${tooltipModalText?.length && 'has-tooltip-modal'}`}
			>
				{inputWrapperLabel}
				{tooltipModalText?.length && (
					<div className="modal-icon-wrapper">
						<Tooltip
							arrow
							title={tooltipModalText}
							placement="top"
							classes={{
								tooltip: classes.customTooltip,
								arrow: classes.customArrow,
							}}
						>
							<TooltipModalIcon />
						</Tooltip>
					</div>
				)}
			</h4>

			{children}
		</div>
	);
};

export default InputWrapper;
